module.exports = __webpack_public_path__ + "static/media/trainspotted-logo.f965f559.svg";